// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__1RfeN","list":"BalanceDue_list__37o_9","listRow":"BalanceDue_listRow__2W2ou","total":"BalanceDue_total__2sbCf"};